import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1af4f2ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"0.5rem"} }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "客户营收管理")
], -1))
const _hoisted_3 = { class: "rightContainer" }
const _hoisted_4 = { class: "rightTotal" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "total-label" }, "月度业绩目标完成率", -1))
const _hoisted_6 = { class: "total-number center-rate" }
const _hoisted_7 = { class: "rightContainer" }
const _hoisted_8 = { class: "rightTotal" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "total-label" }, "月度业绩实际完成值（万元）", -1))
const _hoisted_10 = { class: "total-number center-rate" }
const _hoisted_11 = { class: "rightContainer" }
const _hoisted_12 = { class: "rightTotal" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "total-label" }, "月度业绩目标值（万元）", -1))
const _hoisted_14 = { class: "total-number center-rate" }

import { onMounted, PropType, ref, watch } from 'vue'
import MonthlyTargetCompletion from '@/views/gucangSales/dataBoard/componects/MonthlyTargetCompletion.vue'
import NewActivatedCustomerCount from '@/views/gucangSales/dataBoard/componects/NewActivatedCustomerCount.vue'
import NewActivatedCustomerMonthlyRevenue
  from '@/views/gucangSales/dataBoard/componects/NewActivatedCustomerMonthlyRevenue.vue'
import { getCustomerRevenueDataBoard } from '@/api/gucangSales/dataBoard'


const __default__ = {
  name: 'CustomerRevenueManagement'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    default: 'cos_fbu'
  },
  /// 数据权限查询类型,【没有工号则dataPermissionQueryType1/2,全部数据/指定工号(工号必填)】
  employeeNo: {
    type: String as PropType<string>
  },
  formState: {
    type: Object as PropType<Object>
  }
},
  setup(__props) {


const props = __props
const keyData = ref<any>({})
onMounted(() => {
  getCustomerRevenueDashData()
})
watch(() => props.formState, (val) => {
  getCustomerRevenueDashData()
})
const getCustomerRevenueDashData = () => {
  getCustomerRevenueDataBoard(props.formState)
    .then((res:any) => {
      // 月度业绩目标值
      keyData.value.targetValueTotal = res.data?.targetValueTotal ?? 0
      // 月度业绩实际完成值
      keyData.value.completionValueTotal = res.data?.completionValueTotal ?? 0
      // 月度业绩目标完成率
      keyData.value.targetCompletionRate = res.data?.targetCompletionRate ?? '0%'
    })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_row, { gutter: 8 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("span", _hoisted_6, _toDisplayString(keyData.value.targetCompletionRate), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("span", _hoisted_10, _toDisplayString(keyData.value.completionValueTotal), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("span", _hoisted_14, _toDisplayString(keyData.value.targetValueTotal), 1)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(MonthlyTargetCompletion, {
              appId: "cos_fbu",
              employeeNo: props.employeeNo
            }, null, 8, ["employeeNo"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(NewActivatedCustomerCount, {
              appId: "cos_fbu",
              employeeNo: props.employeeNo
            }, null, 8, ["employeeNo"]),
            _createVNode(NewActivatedCustomerMonthlyRevenue, {
              appId: "cos_fbu",
              employeeNo: props.employeeNo
            }, null, 8, ["employeeNo"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})